import type { FocusEvent, KeyboardEvent, PointerEvent } from "react";

/** Attribute set on an element while its focus came from a pointer (mouse / touch / pen). */
export const POINTER_FOCUS_ATTR = "data-wx-pointer";

/**
 * Handlers that mark an element whose focus came from a POINTER, so its keyboard focus ring can
 * stay off for it. After a click Chrome keeps the button focused but not `:focus-visible`; the
 * next key press anywhere (an arrow or space that scrolls the host page, Shift, ...) flips it to
 * `:focus-visible` and the ring pops in out of nowhere. The mark clears on blur and when the
 * visitor activates the element from the keyboard (Enter / Space), so real keyboard focus keeps
 * its ring. Plain DOM attribute: no re-render per press.
 */
export const pointerFocusHandlers = {
  onPointerDown: (e: PointerEvent<HTMLElement>) => {
    e.currentTarget.setAttribute(POINTER_FOCUS_ATTR, "");
  },
  onBlur: (e: FocusEvent<HTMLElement>) => {
    e.currentTarget.removeAttribute(POINTER_FOCUS_ATTR);
  },
  onKeyDown: (e: KeyboardEvent<HTMLElement>) => {
    if (e.key === "Enter" || e.key === " ") e.currentTarget.removeAttribute(POINTER_FOCUS_ATTR);
  },
};
